﻿$.fn.dxCtrlBcEntete = function custom_dxCtrlBcEntete(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbcentete dx-ctrl");
        this.createInstance(new cdxCtrlBcEntete(this, option));
    }
    return this;
}

window.cdxCtrlBcEntete = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var isSticky = false
    var $Td100 = null
    var $DivSearch = null
    var dxTextBox = null
    var dxBcLienAppli = null
    var disableEventValueChanged = false
    function mConstruit() {
        container.empty();
        container.css({
            "background-attachment": "scroll",
            "background-size": "cover",
            "background-repeat": "no-repeat",
            "background-position": "center",
            "background-image": "url(/ext/imgcognoss/" + gestCognoss.mGetAppliCourante().code_appli_general + ".jpg)"
        })
        container.css("box-shadow", "0 0 8px 4px #000000")

        document.title = gestCognoss.mGetAppliCourante().nom + " Cognoss"
        $("#dynamicfavicon").attr("href", gestCognoss.mGetAppliCourante().img_logo)
        var $DivTop = $("<div style='padding:5px;'/>").appendTo(container)
        var $Table = $("<table style='width:100%;height:62px;'>").appendTo($DivTop)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;padding-right:5px;opacity:1;'/>").appendTo($Tr)
        var $img = $("<img src='" + gestCognoss.mGetAppliCourante().img_logo + "' style='width:60px;border-radius:10px;cursor:pointer;'/>").appendTo($Td)
        $img.on("click", function () { window.open("" + gestCognoss.mGetAppliCourante().urlvitrine, "_blank") })
        var $Td = $("<td style='width:1px;font-size:200%;font-weight:100;opacity:1;white-space:nowrap;line-height:0.7;'/>").appendTo($Tr)
        $("<a href='" + gestCognoss.mGetAppliCourante().urlvitrine + "' target='_blank' style='text-decoration:none;font-size:120%;color:white;font-family:bangers;'>" + gestCognoss.mGetAppliCourante().nom + "<br/><span style='font-size:60%;'>" + gestCognoss.mGetAppliCourante().phrase_accroche + "</span></a>").appendTo($Td)
        $Td100 = $("<td style='width:100%;padding:0 15px;text-align:center;'/>").appendTo($Tr)
        var $Td = $("<td style='width:1px;padding:0 5px;'/>").appendTo($Tr)
        //if (gestCognoss.afficheTicket()) {
        //    $("<div/>").appendTo($Td).dxCtrlBcCnx({
        //        bddCtrl: option.bddCtrl,
        //        readOnly: option.readOnly
        //    })
        //} else 
        if (gestCognoss.afficheDeconnexionBoxCorbeille()) {
            var $Table = $("<table/>").appendTo($Td)
            var $Tr = $("<tr/>").appendTo($Table)
            //var $Td = $("<td/>").appendTo($Tr)
            //$("<div/>").appendTo($Td).dxCtrlButton({
            //    icon: "fafa fafa-mia",
            //    icon2: "fas fa-question",
            //    colorIcone2: theme.colorBtIcon2,
            //    opacityIcone2: "0.9",
            //    hint: "question IA",
            //    onClick: function (e) {
            //        if (option.appli.code_appli.length == 0) {
            //            mNotify("Veuillez sélectionner une appli","error",6000)
            //        } else {
            //            jaugeDemarrage.mShow()
            //            var codeAppli = option.appli.code_appli_general
            //            if (codeAppli=="masc") codeAppli = "ppmasc"
            //            var bdd = new cBdd(codeAppli  + "_aagest", {
            //                allowRappel: false,
            //                allowMsgEmail: false,
            //                allowLoadData: false
            //            })
            //            bdd.mInit(function (bddRef) {
            //                jaugeDemarrage.mHide()
            //                $("<div/>").appendTo("body").dxCtrlPopupIa({
            //                    bddCtrl: bddRef
            //                })
            //            })
            //        }
            //    }
            //})
            var $Td = $("<td/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                text:"Q/R",
                hint: "Gérer les Question/Réponse",
                onClick: function (e) {
                    var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                        position: {
                            my: "right top",
                            at: "right top",
                            of: "body"
                        },
                        hideOnOutsideClick: true,
                        width: 650,
                        height: "100%",
                        showTitle: true,
                        showMaximize: true,
                        title: "Gestion Question/Réponse",
                        contentTemplate: function (contentElement) {
                            $("<div/>").appendTo(contentElement).dxCtrlGridBcQR({ bddCtrl: option.bddCtrl })
                        }
                    }).dxCtrlPopupBase("instance")
                    popup.show();
                }
            })
            var $Td = $("<td/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                icon: "fas fa-boxes",
                onClick: function (e) {
                    var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                        fullScreen: true,
                        showTitle: false,
                        contentTemplate: function (contentElement) {
                            contentElement.css("position", "relative")
                            contentElement.css("padding", "35px 35px 35px 20px")
                            dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:5px'/>").appendTo(contentElement).dxCtrlButton({
                                icon: 'fas fa-times',
                                width: HeightButton,
                                height: HeightButton,
                                onClick: function (e) {
                                    popup.hide()
                                }
                            }).dxCtrlButton("instance");
                            $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPageFileManager({
                                bddCtrl: option.bddCtrl,
                                allowCheck: true,
                                onClickFichier: function (dataGrid) {
                                    page.mAddPopup({
                                        id_fichier: dataGrid.id
                                    }, { fullScreen: true })
                                    //var objFile = new cObjetFile(dataGrid, option.bddCtrl)
                                    //objFile.mShowPopup({})
                                }
                            })
                        }
                    }).dxCtrlPopupBase("instance")
                    popup.show()
                }
            })
            var $Td = $("<td/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                icon: "fas fa-trash-alt",
                onClick: function (e) {
                    var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                        fullScreen: true,
                        showTitle: false,
                        contentTemplate: function (contentElement) {
                            contentElement.css("position", "relative")
                            contentElement.css("padding", "35px 35px 35px 20px")
                            dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:5px'/>").appendTo(contentElement).dxCtrlButton({
                                icon: 'fas fa-times',
                                width: HeightButton,
                                height: HeightButton,
                                onClick: function (e) {
                                    popup.hide()
                                }
                            }).dxCtrlButton("instance");
                            $("<div style=''/>").appendTo(contentElement).dxCtrlGridCorbeille({
                                bddCtrl: option.bddCtrl
                            }).dxCtrlGridCorbeille("instance")
                        }
                    }).dxCtrlPopupBase("instance")
                    popup.show()
                }
            })
            //var $Td = $("<td/>").appendTo($Tr)
            //$("<div/>").appendTo($Td).dxCtrlButton({
            //    icon: "fas fa-power-off",
            //    onClick: function (e) {
            //        jaugeDemarrage.mShow()
            //        window.open(document.URLRacine + "/l/l.aspx", "_self")
            //    }
            //})
            var $Td = $("<td/>").appendTo($Tr)
            var dxMenuUti = $("<div/>").appendTo($Td).dxCtrlMenuUti({
                bddCtrl: option.bddCtrl,
                onlyDisplayProfil: false,
                allowCreateUti: true
            }).dxCtrlMenuUti("instance")
        }

        $DivSearch = $("<div style='width:100%;display:flex;align-items:center;justify-content:center;padding:60px 30px;box-sizing:border-box;'/>").appendTo(container)
        dxTextBox = $("<div style='max-width:600px;width:100%;display:inline-block'/>").appendTo($DivSearch).dxCtrlTextBox({
            labelMode: 'floating',
            label: "Rechercher un article...",
            value: option.textSearch,
            buttons: [{
                name: 'search',
                location: 'before',
                options: {
                    icon: 'fas fa-magnifying-glass',
                    disabled: false,
                    onClick: function () {
                        if (dxTextBox.option("value") != null && dxTextBox.option("value").length > 0) {
                            option.onChangeTextSearch(dxTextBox.option("value"))
                        }
                    },
                    onContentReady: function (e) { e.element.css("opacity", "0.6") }
                }
            }, {
                name: 'effacer',
                location: 'after',
                options: {
                    icon: 'fas fa-xmark',
                    disabled: false,
                    onClick: function () { dxTextBox.option("value", "") },
                    onContentReady: function (e) { e.element.css("opacity", "0.4") }
                }
            }],
            onValueChanged: function (e) {
                if (!disableEventValueChanged) {
                    if (!gestCognoss.isAdmin() && e.value != null && e.value.length > 0) {
                        option.bddCtrl.mAjaxCall({
                            command: "savetxtsearchbc",
                            code_appli: option.appli.bcAppli.code_appli,
                            value: e.value
                        })
                    }
                    option.onChangeTextSearch(e.value)
                }
            },
            onContentReady: function (e) {
                container.find('.dx-texteditor-input').off('keydown.next')
                container.find('.dx-texteditor-input').on('keydown.next', function (ee) {
                    const key = ee.key || ee.keyCode || ee.which;
                    if (key === 'Enter' || key === 13) {
                        ee.preventDefault();
                        let inputs = $('.dx-texteditor-input:visible');
                        let index = inputs.index(this);
                        if (index > -1 && index + 1 < inputs.length) {
                            inputs.eq(index + 1).focus();
                        } else {
                            if (e.component.option("value") != e.component.option('text')) {
                                e.component.option("value", e.component.option('text'))
                            } else {
                                e.component.option("onValueChanged")({
                                    value: e.component.option('text'),
                                    previousValue: e.component.option('text'),
                                    component: e.component,
                                    event: null
                                });
                            }
                        }
                    }
                });
            }
        }).dxCtrlTextBox("instance")

        option.appli = gestCognoss.mGetAppliCourante()
        if (gestCognoss.afficheSelectAppli()) {
            $DivSearch.css("padding", "60px 30px 0px 30px")
            $DivApp = $("<div style='width:100%;display:flex;align-items:center;justify-content:center;padding:0px 30px 60px 30px;box-sizing:border-box;'/>").appendTo(container)
            dxBcLienAppli = $("<div/>").appendTo($DivApp).dxCtrlBcRadioLienAppli({
                bddCtrl: option.bddCtrl,
                value: option.appli,
                onValueChanged: function (value) {
                    option.appli = value
                    option.onChangeAppli(value)
                },
                onDemandeExport: option.onDemandeExport
            }).dxCtrlBcRadioLienAppli("instance")
            option.appli = dxBcLienAppli.option("value")
        }
        //if (typeof utiCnx != 'undefined' && utiCnx != null) {
        //    $DivSearch.css("padding", "60px 30px 0px 30px")
        //    $DivApp = $("<div style='width:100%;display:flex;align-items:center;justify-content:center;padding:0px 30px 60px 30px;box-sizing:border-box;'/>").appendTo(container)
        //    dxBcLienAppli = $("<div/>").appendTo($DivApp).dxCtrlBcRadioLienAppli({
        //        value: option.appli,
        //        onValueChanged: function (value) {
        //            option.appli = value
        //            option.onChangeAppli(value)
        //        }
        //    }).dxCtrlBcRadioLienAppli("instance")
        //    option.appli = dxBcLienAppli.option("value")
        //}
    }

    var disableScrollChange = false
    function mSwitch(dxScroll) {
        if (isSticky) {
            disableScrollChange = true
            dxScroll.scrollTo(dxScroll.scrollTop() + 60)
            dxTextBox.element().fadeOut(150, function () { dxTextBox.element().appendTo($Td100).fadeIn(150) })
            $DivSearch.slideUp(300, function () { disableScrollChange = false })
        } else {
            dxTextBox.element().fadeOut(150, function () { dxTextBox.element().appendTo($DivSearch).fadeIn(150) })
            $DivSearch.slideDown(300)
        }
    }


    this.mChangeScroll = function (dxScroll) {
        if (disableScrollChange) return
        ////var newIsSticky = (scrollTop >= container.innerHeight());
        //var newIsSticky = (dxScroll.scrollTop() >= container.innerHeight());
        var newIsSticky = (dxScroll.scrollTop() > 0);
        if (newIsSticky != isSticky) {
            isSticky = newIsSticky
            mSwitch(dxScroll)
        }
    }

    this.updateSearch = function (textSearch) {
        disableEventValueChanged = true
        dxTextBox.option("value", textSearch)
        disableEventValueChanged = false
    }

    this.element = function () { return container; }

    mConstruit();
}